import { ParcelamentoCartao } from '../../Components/Modal/modal-parcelas'
import { Cidade, Clientes, error99, Estado, ItensVendas, RelatorioConsultaVendas, RetAPI, Usuarios } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'
import { Parcelamento } from '../../Components/Modal/modal-parcelas-crediario'

export type IdentificacaoVenda = {
    idCliente: number,
    nomeConsumidor: string,
    docConsumidor: string,
    ruaConsumidor: string,
    cepConsumidor: string,
    numeroConsumidor: string,
    bairroConsumidor: string,
    ufConsumidor: string,
    idCidConsumidor: number,
    idVendedor: number,
    uf: string,
    idCidade: number,
    obs: string,
}

export type VendaAttribute = {
    estados: Estado[],
    cidades: Cidade[],
    usuarios: Usuarios[],
    clientes: Clientes[],
    identificacao: IdentificacaoVenda,
}

export type Item = {
    id: number,
    nitem: string,
    id_produto: number,
    desc_prod: string,
    qtde: number,
    vl_unit: number,
    vl_tot: number,
    observacao: string,
    id_grade: number,
    cod_barra: string,
}

export const VendasService = {

    FinalizaVenda: async (idVenda: number, parcelamentos: Parcelamento[], parcelamentosCartao: ParcelamentoCartao[], bandeiraCartao: any, numTransacao: any, pagamentos: any[], valor_troco: number, observacao: string): Promise<RetAPI> => {

        /*id_Venda: number | undefined,
        idFPag: number,
        valor: string, */

        const pagamentosEnv: any[] = []

        pagamentos.forEach((item) => {
            if (item && parseFloat(item.valor) > 0) { // Verifica se 'item' não é undefined
                pagamentosEnv.push({
                    "id_fpagto": item.idFPag,
                    "valor": item.valor,
                })
            }
        })

        const resp = await Api('Venda/finalizaVenda', 'put', { id_venda: idVenda, pagamentos: pagamentosEnv, parcelamentos, parcelamentosCartao, bandeiraCartao, numTransacao, valor_troco, observacao })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

        return {
            error: false,
            msg: "",
        }

    },

    GetAttributes: async (idVenda?: string): Promise<RetAPI> => {

        const resp = await Api('Venda/Identificacao', 'get', { id_venda: idVenda })

        const attributes: VendaAttribute = {
            estados: [],
            cidades: [],
            usuarios: [],
            clientes: [],
            identificacao: {
                idCliente: 0,
                nomeConsumidor: '',
                docConsumidor: '',
                ruaConsumidor: '',
                cepConsumidor: '',
                numeroConsumidor: '',
                bairroConsumidor: '',
                obs: '',
                ufConsumidor: '',
                idCidConsumidor: 0,
                idVendedor: 0,
                idCidade: 0,
                uf: '',
            }
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                attributes.identificacao.idCliente = resp.data.identificacao.id_cliente
                attributes.identificacao.nomeConsumidor = resp.data.identificacao.nome_consumidor
                attributes.identificacao.docConsumidor = resp.data.identificacao.cpf_cnpj
                attributes.identificacao.ruaConsumidor = resp.data.identificacao.rua_consumidor
                attributes.identificacao.cepConsumidor = resp.data.identificacao.cep_consumidor
                attributes.identificacao.numeroConsumidor = resp.data.identificacao.numero_consumidor
                attributes.identificacao.bairroConsumidor = resp.data.identificacao.bairro_consumidor
                attributes.identificacao.uf = resp.data.identificacao.uf_consumidor
                attributes.identificacao.idCidConsumidor = resp.data.identificacao.id_cidade_consumidor
                attributes.identificacao.idVendedor = resp.data.identificacao.id_user_venda
                attributes.identificacao.idCidade = resp.data.identificacao.id_cidade_consumidor
                attributes.identificacao.obs = resp.data.identificacao.observacao

                if (resp.data.estados) {
                    attributes.estados = resp.data.estados.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                            sigla: item.sigla,
                            codIBGE: item.cod_ibge,
                        }
                    })
                }

                if (resp.data.cidades) {
                    attributes.cidades = resp.data.cidades.map((item: any) => {
                        return {
                            id: item.codigo,
                            description: item.nome,
                            uf: item.uf,
                            codIBGE: item.codigo,
                        }
                    })
                }

                if (resp.data.clientes) {
                    attributes.clientes = resp.data.clientes.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                        }
                    })
                }

                if (resp.data.usuarios) {
                    attributes.usuarios = resp.data.usuarios.map((item: any) => {
                        return {
                            id: item.id,
                            nome: item.nome,
                            email: '',
                            password: '',
                            ativo: true,
                            id_empresa: 0,
                        }
                    }
                    )
                }

            }
        }

        return {
            error: false,
            data: attributes
        }
    },

    GetAttributesEdit: async (idVenda: any, numItem: any): Promise<RetAPI> => {

        const resp = await Api('V_Item/attributes', 'get', { id_venda: idVenda, nitem: numItem })

        const attributes: Item = {
            id: 0,
            desc_prod: '',
            id_produto: 0,
            nitem: '0',
            observacao: '',
            qtde: 0,
            vl_tot: 0,
            vl_unit: 0,
            id_grade: 0,
            cod_barra: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                attributes.id = resp.data.itemVenda.id
                attributes.desc_prod = resp.data.itemVenda.desc_prod
                attributes.id_produto = resp.data.itemVenda.id_produto
                attributes.nitem = resp.data.itemVenda.nitem
                attributes.observacao = resp.data.itemVenda.observacao
                attributes.qtde = resp.data.itemVenda.qtde
                attributes.vl_tot = resp.data.itemVenda.vl_tot
                attributes.vl_unit = resp.data.itemVenda.vl_unit
                attributes.id_grade = resp.data.itemVenda.id_grade
                attributes.cod_barra = resp.data.itemVenda.cod_barra

            }
        }

        return {
            error: false,
            data: attributes
        }
    },

    SaveVenda: async (): Promise<RetAPI> => {

        const resp = await Api('Venda/Save', 'post')

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                data: resp.data.venda
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    SaveItemVenda: async (V_Item: ItensVendas): Promise<RetAPI> => {

        const resp = await Api('V_Item/Save', 'post', {
            id_venda: V_Item.id_venda,
            cod_barra: V_Item.cod_barra,
            referencia: V_Item.referencia,
            qtde: V_Item.qtde,
            vl_unit: V_Item.vl_unit,
            idGrade: V_Item.idGrade,
            nitem: V_Item.numItem,
            obsItem: V_Item.obsItem,
            idProduto: V_Item.id_produto,
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',
                data: resp.data
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    CancelarVendaItem: async (id_venda: number, nitem: number): Promise<RetAPI> => {

        const resp = await Api('V_Item/Cancel', 'put', {
            id_venda: id_venda,
            nitem: nitem,
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',

                }
            }

            return {
                error: false,
                data: resp.data.venda
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    CancelarVenda: async (id_venda: number, senha: string, motivo: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api('Venda/Cancel', 'put', { id_venda: id_venda, senha: senha, motivo: motivo })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',

                }
            }

            return {
                error: false,
                msg: ''
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    VendaDesconto: async (id_venda: number, valor_desconto: any): Promise<RetAPI> => {

        const resp = await Api('Venda/Desconto/Save', 'put', {

            id_venda: id_venda,
            valor_desconto: valor_desconto,
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                data: resp.data.venda
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    VendaPorPeriodo: async (datai: string, dataf: string, vendedores?: number[], orderBy?: string): Promise<RetAPI> => {

        const resp = await Api('Venda/relatorio/periodo', 'get', {

            datai: datai,
            dataf: dataf,
            vendedores: vendedores && vendedores?.length > 0 ? JSON.stringify(vendedores) : '',
            orderBy: orderBy
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                data: resp.data.vendas,
                valor_total_bruto: resp.data.valor_total_bruto,
                valor_total_liquido: resp.data.valor_total_liquido,
                valor_total_desconto: resp.data.valor_total_desconto,
                quantidade_registro: resp.data.quantidade_registro,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    VendaItensPorPeriodo: async (datai: string, dataf: string, vendedores?: number[], orderBy?: string): Promise<RetAPI> => {

        console.log("vendedores: ", vendedores)
        console.log("JSON.stringify(vendedores): ", JSON.stringify(vendedores))
        const resp = await Api('Venda/relatorio/vendas_itens', 'get', {
            datai: datai,
            dataf: dataf,
            vendedores: vendedores && vendedores?.length > 0 ? JSON.stringify(vendedores) : '',
            orderBy: orderBy
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                data: resp.data.vendas,
                valor_total_bruto: resp.data.valor_total_bruto,
                valor_total_liquido: resp.data.valor_total_liquido,
                valor_total_desconto: resp.data.valor_total_desconto,
                quantidade_registro: resp.data.quantidade_registro,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    ResumoVendasItens: async (datai: string, dataf: string, grupo?: any): Promise<RetAPI> => {

        const resp = await Api('Venda/relatorio/resumo_itens', 'get', {
            datai: datai,
            dataf: dataf,
            grupo: grupo
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                data: resp.data.vendas,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    VendasProdutoCliente: async (datai: string, dataf: string, id_produto: any): Promise<RetAPI> => {

        const resp = await Api('Venda/relatorio/produto_cliente', 'get', {
            datai: datai,
            dataf: dataf,
            id_produto: id_produto
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                data: resp.data.vendas,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    IdentificarConsumidorVenda: async (dadosConsumidor: any): Promise<RetAPI> => {

        const resp = await Api('Venda/Consumidor/Identificar', 'put', {
            id_venda: dadosConsumidor.id_venda,
            id_consumidor: dadosConsumidor.id_consumidor,
            nome_consumidor: dadosConsumidor.nome_consumidor,
            doc: dadosConsumidor.doc,
            logradouro: dadosConsumidor.logradouro,
            bairro: dadosConsumidor.bairro,
            numero: dadosConsumidor.numero,
            complemento: dadosConsumidor.complemento,
            uf: dadosConsumidor.uf,
            id_cidade: dadosConsumidor.id_cidade,
            observacao: dadosConsumidor.observacao,
            cep: dadosConsumidor.cep,
            id_vendedor: dadosConsumidor.idVendedor,
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    CancelarIdentificarConsumidorVenda: async (id_venda: any): Promise<RetAPI> => {

        const resp = await Api('Venda/Consumidor/CancelaIdentificacao', 'put', { id_venda })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    CadastrarVendaPagamento: async (id_venda: any, id_fpagto: any, valor: any, parcelamento: Parcelamento[]): Promise<RetAPI> => {

        const resp = await Api('Venda/Pagamento/Create', 'post', { id_venda, id_fpagto, valor, parcelamento })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',
                data: resp.data.pagamentos

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    ImprimirVenda: async (ip: any, porta: any, id_venda: any, path_impressora?: any): Promise<RetAPI> => {

        const resp = await Api('Venda/Print', 'get', { ip, porta, id_venda, path_impressora })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    ConsultarVendas: async (relatorio: any): Promise<RetAPI> => {

        const resp = await Api('Venda/relatorio/vendaDetalhada', 'get', {
            datai: relatorio?.datai,
            dataf: relatorio?.dataf,
            id_vendedor: relatorio?.id_vendedor,
            id_cliente: relatorio?.id_cliente,
            id_venda: relatorio?.id_venda,
            tipo_venda: relatorio?.tipo_venda
        })

        const attributes: RelatorioConsultaVendas[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.vendas) {

                    resp.data.vendas.map((item: RelatorioConsultaVendas) => {
                        const venda: any = {
                            id: item.id,
                            data_hora: item.data_hora,
                            vl_bruto: item.vl_bruto,
                            qtd_itens: item.qtd_itens,
                            vl_troco: item.vl_troco,
                            vl_desc: item.vl_desc,
                            vl_acre: item.vl_acre,
                            vl_liquido: item.vl_liquido,
                            id_user_insert: item.id_user_insert,
                            id_cliente: item.id_cliente,
                            status: item.status,
                            observacao: item.observacao,
                            vl_bc_icms: item.vl_bc_icms,
                            vl_icms: item.vl_icms,
                            vl_bc_pis_cofins: item.vl_bc_pis_cofins,
                            vl_pis: item.vl_pis,
                            vl_cofins: item.vl_cofins,
                            vl_bc_st: item.vl_bc_st,
                            vl_st: item.vl_st,
                            vl_frete: item.vl_frete,
                            id_user_last_update: item.id_user_last_update,
                            dt_last_update: item.dt_last_update,
                            dh_faturamento: item.dh_faturamento,
                            num_nf: item.num_nf,
                            id_user_faturamento: item.id_user_faturamento,
                            id_empresa: item.id_empresa,
                            nome_consumidor: item.nome_consumidor,
                            cpf_cnpj: item.cpf_cnpj,
                            rua_consumidor: item.rua_consumidor,
                            cep_consumidor: item.cep_consumidor,
                            numero_consumidor: item.numero_consumidor,
                            bairro_consumidor: item.bairro_consumidor,
                            uf_consumidor: item.uf_consumidor,
                            id_cidade_consumidor: item.id_cidade_consumidor,
                            id_user_cancel: item.id_user_cancel,
                            dh_cancel: item.dh_cancel,
                            id_user_venda: item.id_user_venda,
                            name_user_insert: item.name_user_insert,
                            name_user_venda: item.name_user_venda,
                            itens: [], // Array de itens para ser populado
                            pagamentos: [], // Array de pagamentos para ser populado
                            DadosCliente: {
                                id: item.DadosCliente?.id,
                                nome: item.DadosCliente?.nome,
                                endereco: item.DadosCliente?.endereco,
                                bairro: item.DadosCliente?.bairro,
                                numero: item.DadosCliente?.numero,
                                cnpj_cpf: item.DadosCliente?.cnpj_cpf,
                                ie_rg: item.DadosCliente?.ie_rg,
                                nome_cidade: item.DadosCliente?.nome_cidade,
                                cep: item.DadosCliente?.cep,
                                nome_fantasia: item.DadosCliente?.nome_fantasia,
                                uf: item.DadosCliente?.uf,
                                complemento: item.DadosCliente?.complemento,
                                contato: {
                                    telefone: item.DadosCliente?.contato?.telefone,
                                    celular: item.DadosCliente?.contato?.celular,
                                    nome: item.DadosCliente?.contato?.nome,
                                    email: item.DadosCliente?.contato?.email
                                }
                            },
                            Crediario: []
                        }

                        // Popula os itens da venda
                        item.itens.map((it: any) => {
                            venda.itens.push({
                                id: it.id,
                                nitem: it.nitem,
                                id_produto: it.id_produto,
                                desc_prod: it.desc_prod,
                                cod_barra: it.cod_barra,
                                qtde: it.qtde,
                                vl_unit: it.vl_unit,
                                vl_custo: it.vl_custo,
                                vl_tot: it.vl_tot,
                                vl_desc: it.vl_desc,
                                vl_bc_icms: it.vl_bc_icms,
                                p_icms: it.p_icms,
                                cst_icms: it.cst_icms,
                                origem_produto: it.origem_produto,
                                vl_icms: it.vl_icms,
                                vl_bc_pis_cofins: it.vl_bc_pis_cofins,
                                p_pis: it.p_pis,
                                vl_pis: it.vl_pis,
                                p_cofins: it.p_cofins,
                                vl_cofins: it.vl_cofins,
                                cst_pis_cofins: it.cst_pis_cofins,
                                vl_bc_st: it.vl_bc_st,
                                vl_st: it.vl_st,
                                vl_frete: it.vl_frete,
                                status: it.status,
                                dh_insert: it.dh_insert,
                                dh_cancel: it.dh_cancel,
                                id_user_cancel: it.id_user_cancel,
                                id_user_last_update: it.id_user_last_update,
                                dt_last_update: it.dt_last_update,
                                desc_unid_medida: it.desc_unid_medida,
                                observacao: it.observacao,
                            })
                        })

                        // Popula os pagamentos da venda
                        item.pagamentos.map((pgto: any) => {
                            venda.pagamentos.push({
                                descricao: pgto.descricao,
                                id_fpagto: pgto.id_fpagto,
                                valor: pgto.valor
                            })
                        })

                        if (item.Crediario) {
                            item.Crediario.map((crediario: any) => {
                                venda.Crediario.push({
                                    data_vencimento: crediario.data_vencimento,
                                    serie: crediario.serie,
                                    valor: crediario.valor,
                                    observacao: crediario.observacao,
                                    dt_cadastro: crediario.dt_cadastro
                                })
                            })
                        }

                        // Adiciona a venda ao array de vendas
                        attributes.push(venda)
                    })
                }
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

}
